import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../components/AuthContext";

/**
 * Użycie:
 * <RequireRole roles={['student','parent']}>...</RequireRole>
 * lub <RequireRole roles={['parent']}>...</RequireRole>
 */
export default function RequireRole({ roles = [], children }) {
  const { user, isAuthReady } = useContext(AuthContext);
  const location = useLocation();

  if (!isAuthReady) return null;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (user.role === "admin") return children;
  if (!roles.includes(user.role)) return <Navigate to="/konto" replace />;
  return children;
}
